import {withTranslation} from '@wix/yoshi-flow-editor'
import {isMobile} from '../../../../../../commons/selectors/environment'
import {getUpdatesCount} from '../../../selectors/groups'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {GroupActivity as Presentation} from './group-activity'
import {GroupActivityOwnProps, GroupActivityRuntimeProps} from './interfaces'

const mapRuntime = ({state}: DetailsPageAppProps): GroupActivityRuntimeProps => ({
  updatesCount: getUpdatesCount(state),
  isMobile: isMobile(state),
})

export const GroupActivity = connect<GroupActivityOwnProps, GroupActivityRuntimeProps>(mapRuntime)(
  withTranslation()(Presentation),
)
